import { app } from '@/main';
import { sleep } from '@/utils';

import { IRouterProps } from '@/router/interfaces/router-props.interface';
import recaptchaRoutesKeys from '@/constants/recaptchaRoutesKeys';
import { checkTestABSignUpInitiative } from '@/utils/abTest';

import Module from '../interfaces/module.interface';
import { RootState } from '../types';
import APIService from '@/api';

const factory = async (context: IRouterProps) => {
  // REMOVED DUE TO END OF THE EXPERIMENT 2024 Q1
  // if (!APIService.token) {
  //   // Note: It's necessary so that an incognito window generates the recaptcha correctly
  //   await sleep(0);
  //   const recaptcha = await app.$recaptcha(recaptchaRoutesKeys.testAB);
  //   await Promise.all([checkTestABSignUpInitiative(recaptcha)]);
  // }
};

export const abTests: Module<any, RootState> = {
  namespaced: true,
  initializer: {
    factory,
    provide: 'AbTestsStore',
    on: 'BeforeEachRoute'
  }
};
